import type { Conf, UserEvent } from 'src/global';
import {
    addTags,
    disableChat,
    enableChat,
    getZe,
    handleFeaturesSupression,
    monitorUserEvent,
    setPendoChatDisplay,
    setSalesText,
} from 'src/util';
import waitForDepartment from 'src/waitForDepartment';

const isPendo = typeof window.pendo?.loadGuides === 'function';

export const loadSales = (conf: Conf) => {
    const zE = getZe();

    const switchChat = (isOnline: boolean) => {
        if (isOnline) {
            setPendoChatDisplay('block');
            enableChat(conf);
            !isPendo && zE.show();
        } else {
            setPendoChatDisplay('none');
            disableChat();
            isPendo && window.pendo?.loadGuides();
            !conf.username && zE.hide(); // for anonymous user on /pricing
        }
    };

    const setupForUrls = () => {
        location.href.includes('/upgrade') ? zE.show() : zE.hide();
    };

    const minimizedShow = () => {
        zE('webWidget:on', 'userEvent', (event: UserEvent) => {
            if (event.action === 'Web Widget Minimised') {
                zE.show();
            }
        });
    };

    if (conf.isTeamUser) {
        zE.hide();
        setPendoChatDisplay('none');
        handleFeaturesSupression(['answerBot', 'talk', 'chat'], ['helpCenter']);
        return;
    }

    handleFeaturesSupression(['helpCenter', 'answerBot', 'talk']);
    monitorUserEvent(conf);
    setSalesText();
    minimizedShow();
    setupForUrls();
    addTags(['sales_pages'], conf);

    waitForDepartment(switchChat, conf.waitCount, conf);
};

export default loadSales;
